import React from 'react';
import axios from 'axios';
import config from '../config';
import sheetsIcon from '../assets/sheetsicon.png';
import '../styles/FeedbackDownloadExcel.css';

const AtendimentoDownloadExcel = () => {
  const handleDownload = async () => {
    const token = localStorage.getItem('token');

    try {
      const response = await axios.get(`${config.apiUrl}/atendente/excel`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      const nomeArquivo = response.headers['content-disposition']
        ?.split('filename=')[1]
        ?.replace(/"/g, '') || 'atendimentos.xlsx';

      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error('Erro ao fazer download do Excel:', err);
    }
  };

  return (
    <div className="feedback-download-container">
      <button onClick={handleDownload}>
        <img src={sheetsIcon} alt="Google Sheets" className="sheets-icon" />
        Download Excel
      </button>
    </div>
  );
};

export default AtendimentoDownloadExcel;
